const details = Array.from(document.querySelectorAll('.mel-faq'));
const urlParams = new URLSearchParams(window.location.search);
let id = urlParams.get('faq');

// Función para actualizar el parámetro "faq" de la URL
const updateUrl = () => {
  const url = new URL(window.location.href);
  if (id) {
    url.searchParams.set('faq', id);
  } else {
    url.searchParams.delete('faq');
  }
  window.history.replaceState({}, '', url);
};

details.forEach((detail) => {
  const detailId = detail.getAttribute('data-id');

  // Comprobamos si el id del detail coincide con el id de la URL
  if (detailId === id) {
    detail.open = true;
    detail.scrollIntoView();
  }

  detail.addEventListener('click', () => {
    const active = details.find((d) => d.open);

    // Actualizamos el parámetro "faq" de la URL
    if (detail.open) {
      id = null;
    } else {
      id = detailId;
    }
    updateUrl();

    if (!detail.open && active) {
      active.open = false;
    }
  });
});
